import { useTranslation } from 'react-i18next';
import { LmsCurriculumMode } from 'src/graphql/generated/graphql';

export const CurriculumModeColumn = ({
  mode,
}: {
  mode?: LmsCurriculumMode;
}) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'lms.curriculum.list.columns.mode',
  });

  if (!mode) {
    return null;
  }

  const MODE_MAP = {
    [LmsCurriculumMode.SelfPacedOnline]: t('self-paced'),
    [LmsCurriculumMode.VirtualInstructor]: t('virtual-instructor'),
    [LmsCurriculumMode.InPerson]: t('in-person'),
  };

  return MODE_MAP[mode];
};
